import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region ../icons/dist/react/default/pause.js
const PauseIcon = (props, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 18,
	fill: "currentColor",
	"aria-hidden": "true",
	viewBox: "0 0 18 18",
	ref,
	...props,
	children: [/* @__PURE__ */ jsx("rect", {
		width: 5,
		height: 14,
		x: 2,
		y: 2,
		rx: 1.75
	}), /* @__PURE__ */ jsx("rect", {
		width: 5,
		height: 14,
		x: 11,
		y: 2,
		rx: 1.75
	})]
});
const ForwardRef = forwardRef(PauseIcon);
//#endregion
export { ForwardRef as default };

//# sourceMappingURL=pause.js.map